/* drawer */
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    if (this.classList.contains('active')) { 

      }else{
        var elements = document.getElementsByClassName('active');
        while(elements.length > 0){
          elements[0].classList.remove('active');
        }
        var rotate = document.getElementsByClassName('rotate-up');
        while(rotate.length > 0){
          rotate[0].classList.remove('rotate-up');
        }
        var panels = document.getElementsByClassName('panel-show');
        while(panels.length > 0){
          panels[0].classList.remove('panel-show');
        }
    }

    this.classList.toggle("active");
    this.previousElementSibling.classList.toggle("rotate-up");
    this.nextElementSibling.classList.toggle("panel-show");
    

  });
} 
$(document).ready(function() {
/* working on the menu double click isssue / hide - show megamenu */
  $('.mega-menu-parent').click(function(event) { 
    event.preventDefault();
    var clickNumb = $(this).attr('data-click-count');
    var data  = $(this).attr('data-dropdown-rel');
    console.log(clickNumb);
    if ( clickNumb % 2 == 0){
      $(this).removeClass('active_link');
        $(".mega-menu").each(function() {
          var kud = $(this).attr('data-dropdown');
            if ( kud == data){
              $(this).hide();
            }
        });
    }
  });  

  // remove the data-click-count attr on tablet and mobile devices
  $('.mobile_nav').attr(' data-click-count',-1);

});

/* thumbnail effect on keyup */
$(document).ready(function () {
    $('.product-gallery__thumbnail').first().addClass('active_thumb');
  
});
                  
$( ".product-gallery__thumbnail" ).click(function() {
  $(this).siblings('.product-gallery__thumbnail').removeClass('active_thumb').end().addClass('active_thumb');
});

$('.flickity-button.flickity-prev-next-button.next').click(function() {
  $('.product-gallery__thumbnail').removeClass('active_thumb');
});



$(document).ready(function () {
  /* Add class to megamenu columns with image */
  $(".dropdown_column").each(function() {
    if($(this).find('.image-element__wrap').length !== 0){
      $(this).addClass('mega-w-img');
    }
  });
  /* Add class to megamenu mobile sub cat level 2 keeping it folded */
  $(".mobile-mega-menu_block ul").each(function() {
    $(this).css('display' , 'block');
  });
  

 
  /* checking the number of main menu elements and adjusting the grid accordingly */
  var elnum = $('.nav--combined .menu.center li').length;
  elnum = elnum - 2;
  $('.nav--combined .menu.center').css('grid-template-columns' , '133px repeat('+ elnum + ' , 1fr) 137px');
 
});

/* custom slider for collection list section */
$('.next-slider').click(function() {
  if ($(window).innerWidth() > 502) {

    var targetted = $(this).closest('.column').siblings( '.column' ).find('.is-flex-wrap');
    var far = targetted.width() +30 ;
    var pos = targetted.scrollLeft() + far;
    targetted.animate( { scrollLeft: pos }, 700 );
  }else {
    var targetted = $(this).closest('.column').siblings( '.column' ).find('.is-flex-wrap');
    var far = $(window).innerWidth() +30;
    var pos = targetted.scrollLeft() + far;
    targetted.animate( { scrollLeft: pos }, 700 );

  }

});

$('.prev-slider').click(function() {
  if ($(window).innerWidth() > 502) {
  var targetted = $(this).closest('.column').siblings( '.column' ).find('.is-flex-wrap');
  var far = targetted.width() + 30;
  var pos = targetted.scrollLeft() - far ;
  targetted.animate( { scrollLeft: pos }, 700 );
  }else{
    var targetted = $(this).closest('.column').siblings( '.column' ).find('.is-flex-wrap');
    var far = $(window).innerWidth() + 30;
    var pos = targetted.scrollLeft() - far;
    targetted.animate( { scrollLeft: pos }, 700 );
  }
});



// Add smooth scrolling to all links

$(document).ready(function(){
  $(".caption-content a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();
      // Store hash
      var hash = this.hash;
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });

  $(".image-text-container .global-button").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();
      // Store hash
      var hash = this.hash;
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });


  /* Select date picker */ 
  $("#textfield-11").attr('type','date');
 
  $('.insta-feed .title').click(function() {
    var kuda = $('.insta-feed .hidden-product-link').attr('href');
    window.open(kuda, '_blank');

  }); 
  $('.insta-feed .one-fourth').removeClass('small-down--one-whole');
  $('.image-text-container .collection_title').attr('href','#');

});

$('.cart-container').click(function(event) {
  event.preventDefault();
  $(location).attr('href','/cart');
}); 

$('.full-cart').click(function(event) {
  event.preventDefault();
  $(location).attr('href','/cart');
}); 


/* hiding forms on submit*/ 
$( document ).ready(function() {
  var location = window.location.href;
  if($('#contact_form .quote').text()!==undefined && $('#contact_form .quote').text()!==''){
    $('.custom-contact-form__blocks').hide();
    $('#contact_form input , #contact_form textarea, #contact_form button').hide();    
     
  }
  if($('#contact_form em').text()!==undefined && $('#contact_form em').text()!==''){
    $('.custom-contact-form__blocks').hide();
    $('#contact_form input , #contact_form textarea, #contact_form button').hide();    
   
  }
  if( location.indexOf('contact_posted=true') >= 0 ){
      $('.footer .custom-contact-form__blocks').show();
      $(' .footer  #contact_form input , .footer   #contact_form textarea,.footer   #contact_form button').show();   
  }else if( location.indexOf('customer_posted=true') >= 0 ) {
      $('.shopify-section--contact-section .custom-contact-form__blocks').show();
      $(' .shopify-section--contact-section  #contact_form input , .footer   #contact_form textarea,.footer   #contact_form button').show();   
  }
  
  
});

// email frontend validator 
function ValidateEmail(mail) {
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)){
    return (true)
  }
    return (false)
}

let error = document.querySelector('#error');
let input = document.querySelector('#contact_email_checker');
let submitController = document.querySelector('#newsletter-form__sign-up'); 
input.onblur = function() {
    if(!ValidateEmail(input.value)){
      input.classList.add('invalid');
      error.innerHTML = 'Please enter a valid email address';
      submitController.disabled = true;
    }
};

input.onfocus = function() {
  if (this.classList.contains('invalid')) {
    this.classList.remove('invalid');
    error.innerHTML = "";
    submitController.disabled = false;
  }
};



/* adjusting one half medium-down--one-whole on 500px */
$( document ).ready(function() {
  if ($(window).innerWidth() < 502) {
    $('.c-list .one-fourth').removeClass('medium-down--one-half');
    $('.c-list .one-fourth').addClass('medium-down--one-whole');
  }
  

  
 /* if ($(window).innerWidth() < 800) {
    $('.sidebar-block').attr('data-sidebar-block', 'close');
    $('.sidebar-block').removeAttr('open');
    $('.sidebar-block').attr('close', 'close');
  }*/


});

/* nice select functionality */
$(document).ready(function() {
  $('.product-qty-new').niceSelect();
  $('#sort-by').niceSelect();
});

/* sort functionality workflow change on mobile */
$('.sort_by.show_mobile a').click(function(event) {
  event.preventDefault();
  $('.results__btn').addClass('has_sorted_element');
  $('.sort_by.show_mobile a').removeClass('sort_selected');
  $(this).addClass('sort_selected');
  var distination  = $(this).attr('href');
   distination = distination.split('=');
   distination = distination[1];
   $('#sort-by').val(distination).trigger('change');
});

$(document).ready(function() {
  $('.insta-feed .hidden-product-link').attr('target' , '__blank');
  //$('.mega-menu__image-caption-link a').removeAttr('target');

});

/* scroll to review section */
$('.product-block--price').click(function() {
  $(".spr-container").get(0).scrollIntoView({block: "center", behavior: "smooth"});
}); 


$('.icon-right__arrow_show').click(function() {
  $("#shopify-section-template--15454363320534__16383932632bf4faf8").get(0).scrollIntoView({block: "center", behavior: "smooth"});
}); 


$(window).on("load", function (e) {
  $('.gs__checkbox-input-title').text('Add gift message?');
 // $('.mega-menu-parent').attr('onclick' , 'event.preventDefault();');

}); 





$('.ig_regular').hover(function() { 
  $(this).hide();
  $('.ig-default-hover').removeClass('hide');
}); 

$('.ig-default-hover').mouseout(function() { 
  $(this).addClass('hide');
  $('.ig_regular').show();
}); 


window.addEventListener('load', function() {
  let current = window.location.href;
  if( current.indexOf('/collections/vendors?')>= 0  ){
    var url = current.split('vendors?q=');
    var title = decodeURI(url[1]);
    title =  title.replace(" ", "-");
    window.location.href = "/collections/" + title;
    }
});



if (($(window).width() > 766) ){   
  $(window).on("orientationchange",function(){
       location.reload(); 
  });   
}

$( document ).ready(function() {
    var gift_title = $(".swatch_options input:checked+.swatch-element").attr("data-value");
    $(".giftCardOptionTitle span").text(gift_title);

    $(".gift_option_img").on("click", function (e) {
      $(".giftCardOptionTitle span").text($(this).attr("data-value"));
    });   

    var stateSelect = $(".custom_address .state_form").attr("data-default");

    

     if(jQuery(".custom_address .state_form option").text() == stateSelect ){
       $(this).attr('selected','selected');
     }
jQuery( ".custom_address .state_form option" ).each(function( index ) {
     if(jQuery(this).text() == stateSelect ){
       $(this).attr('selected','selected');
     }
});



    $(".mobile_navigation_button").on("click", function (e) {
      $(".mobile_filter_panel").addClass("show_menu");
    });

    $(".panel_close").on("click", function (e) {
      $(".mobile_filter_panel").removeClass("show_menu");
    });
  
  
});

